import {api} from "../api";

export function calculateDetails(enregistrement) {
    return api.post('EnregistrementEntete/CalculDetails/', JSON.stringify(enregistrement), false); // Devrait être un GET pour être RESTful, mais les paramètres envoyés sont complexes et peuvent résulter en un URL dépassant la limite de plusieurs browsers si envoyé en GET.
}

export function processTransactionDroitAcces(parameters) {
    return api.post('EnregistrementEntete/DroitAcces/', JSON.stringify(parameters), false);
}

export function getPDFLastEnregistrement(idProfile, language) {
    return api.get(`Enregistrement/${ idProfile }/reimprimerDernierEnregistrementByIdProfile/?language=${ language }`, false);
}